import { useSyncExternalStore } from 'react';
import { getState, subscribe, type MaintenanceState } from '@lib/maintenance';

const SSR_SNAPSHOT: MaintenanceState = {
  status: 'ready',
  customMessage: '',
  lastChangedAt: 0,
};

/**
 * React hook returning the current maintenance state.
 * Re-renders on every state change.
 *
 * The SSR snapshot returns 'ready' so the takeover never flashes
 * on the very first paint before subscription stabilizes.
 */
export function useMaintenanceState(): MaintenanceState {
  return useSyncExternalStore(subscribe, getState, () => SSR_SNAPSHOT);
}
